import React from 'react';
import { View, StyleSheet } from 'react-native';


const MAX_DOT_SIZE = 20;

const styles = StyleSheet.create({
  containerStyle: { justifyContent: 'center', alignItems: 'center' },
  dot: { borderRadius: 20 },
});

const WeightDot = ({
  color,
  maxDotSize = MAX_DOT_SIZE,
  containerStyle,
  style,
  weight,
}) => {
  const size = Math.min(1.5 + (weight * 0.5), maxDotSize);

  return (
    <View style={[styles.containerStyle, { width: maxDotSize, height: maxDotSize }, containerStyle]}>
      { weight ? (
        <View style={[
          styles.dot,
          {
            width: size, height: size, backgroundColor: color,
          },
          style,
        ]}
        />
      ) : null }
    </View>
  );
};

export default WeightDot;
